import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isAppInitialized: false,
  jwtCode: undefined,
  routes: ['/'],
  modules: [],
  openModules: [],
  landUrl: '',
};

export const BaseReducer = createSlice({
  name: 'base',
  initialState,
  reducers: {
    setAppInitialize: (state, action) => {
      const { value } = action.payload;
      state.isAppInitialized = value;
    },
    setJWTCode: (state, action) => {
      const { value } = action.payload;
      state.jwtCode = value;
    },
    setRoutes: (state, action) => {
      const { value } = action.payload;
      state.routes = value;
    },
    setModules: (state, action) => {
      const { value } = action.payload;
      const activeMenu = [];
      if (value) {
        state.modules = value?.routes.map((item) => {
          activeMenu.push(item.path);
          const children =
            item.children?.length > 0
              ? item?.children?.map((child) => {
                  return {
                    key: child.path,
                    label: child.name,
                    path: child.path,
                  };
                })
              : undefined;
          return {
            key: item.path,
            label: item.name,
            path: item.path,
            children,
          };
        });
        state.openModules = activeMenu;
        state.landUrl = value?.defaultLandUrl;
      }
    },
  },
});
export const { setRoutes, setAppInitialize, setJWTCode, setToken, setModules } = BaseReducer.actions;

export default BaseReducer.reducer;
